<template>
  <Motion class="p-6 space-y-4 animate-fade-in">
    <div class="flex items-center gap-3">
      <img src="/images/off-road-edition.svg" alt="Off-Road" class="w-8 h-8" />
      <h2 class="text-white text-xl font-semibold">Off-Road Edition</h2>
    </div>
    <p class="text-slate-400 text-sm">
      Rugged workflows and specialized tools designed for local use when SHTF. Coming soon.
    </p>
    <div class="panel-neo panel-neo--glassier p-5">
      <div class="text-slate-300 text-sm">
        The TestDrive Off-Road Edition is a near real-time backup of TestDrive data and a desktop
        app that provides basic app functionality when the web app is down.
      </div>
    </div>
  </Motion>
</template>

<script setup lang="ts">
import { Motion } from 'motion-v'
</script>
